// ─────────────────────────────────────────────────────────────
// Theme — Dark / Light mode management
// ─────────────────────────────────────────────────────────────

type Theme = 'dark' | 'light';

const STORAGE_KEY = 'travelle-theme';
const TOGGLE_IDS  = ['theme-toggle-btn', 'theme-toggle-nav'] as const;

export function initTheme(): void {
  const saved      = localStorage.getItem(STORAGE_KEY) as Theme | null;
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  applyTheme(saved ?? (prefersDark ? 'dark' : 'light'));
}

export function applyTheme(theme: Theme): void {
  document.documentElement.setAttribute('data-theme', theme);
  localStorage.setItem(STORAGE_KEY, theme);

  const icon = theme === 'dark' ? '🌙 Light Mode' : '☀️ Dark Mode';
  TOGGLE_IDS.forEach(id => {
    const el = document.getElementById(id);
    if (el) el.textContent = icon;
  });
}

export function toggleTheme(): void {
  const current = (document.documentElement.getAttribute('data-theme') ?? 'light') as Theme;
  applyTheme(current === 'dark' ? 'light' : 'dark');
}

export function currentTheme(): Theme {
  return (document.documentElement.getAttribute('data-theme') ?? 'light') as Theme;
}
